import { UploadFile } from "@/api/upload/index.js";

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
    //
    UploadFile(context, payload) {
        return new Promise((resolve, reject) => {
            UploadFile(payload).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}